import {
  MailOutlined,
  MessageOutlined,
  PhoneOutlined
} from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import { useI18n } from '../i18n';

const { Title, Paragraph, Text } = Typography;

const ShoppingGuidePage: React.FC = () => {
  const { t } = useI18n();

  // 联系信息数据
  const contactInfo = [
    {
      icon: <MailOutlined style={{ fontSize: '48px', color: '#17a2b8' }} />,
      title: t('shoppingGuide.contact.serviceEmail.title'),
      content: t('shoppingGuide.contact.serviceEmail.address')
    },
    {
      icon: <PhoneOutlined style={{ fontSize: '48px', color: '#17a2b8' }} />,
      title: t('shoppingGuide.contact.servicePhone.title'),
      content: t('shoppingGuide.contact.servicePhone.number')
    },
    {
      icon: <MessageOutlined style={{ fontSize: '48px', color: '#17a2b8' }} />,
      title: t('shoppingGuide.contact.lineService.title'),
      content: t('shoppingGuide.contact.lineService.id')
    }
  ];

  return (
    <div>
      <section className="py-5" style={{ width: '100%' }}>
        <img src={'/img/phone/28.jpg'} style={{ width: '100%' }} alt="spacing" className="img-fluid" />
      </section>
    </div>
  );
}

export default ShoppingGuidePage;
